import { formatDate, formatNumber } from 'devextreme/localization';
import { useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Field, Panel } from '../../../../layouts';
import { ROType } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function MaterialOrderInformationPanel() {

	const { order } = useContext(RetailOrderContext);
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	return (
		<>
			<Panel header={'Material Order Information'}>
				{
					order.details.materialOrders && order.details.materialOrders.length === 1 &&
					<>
						<Field label={'MO Number'} >
							<Link to={'/cfi/retail-order/' + order.details.retailOrderID + '/130/' + order.details.materialOrders[0].materialOrderID +
								(!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
								{order.details.materialOrders[0].moNumber}
							</Link>
						</Field>
						<Field label={'Order Type'} >{order.details.materialOrders[0].moType}</Field>
						<Field label={'Order Status'} >{order.details.materialOrders[0].orderStatus}</Field>
						<Field label={'Order Date'} >{formatDate(new Date(order.details.materialOrders[0].moDate), 'shortDate')}</Field>
						<Field label={'Amount'} >{formatNumber(order.details.materialOrders[0].amount, { type: 'currency', precision: 2 })}</Field>
					</>
				}

				<Field label={'Material Orders'} visible={order.details.materialOrders && order.details.materialOrders.length > 1}>
					<table className='material-orders'>
						<tbody>
							{
								order.details.materialOrders.map((mo) => {
									return (
										<tr key={mo.materialOrderID}>
											<td>
												<Link to={'/cfi/retail-order/' + order.details.retailOrderID + '/130/' + mo.materialOrderID +
													(!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
													{mo.moNumber}
												</Link>
											</td>
											<td>
												{formatNumber(mo.amount, { type: 'currency', precision: 2 })}
											</td>
										</tr>
									)
								})
							}
							<tr>
								<td></td>
								<td className='mo-total'>
									{formatNumber(order.details.materialOrders.reduce((a, b) => a + b.amount, 0), { type: 'currency', precision: 2 })}
								</td>
							</tr>
						</tbody>
					</table>
				</Field>
			</Panel>
		</>
	);
}
